// extracted by mini-css-extract-plugin
export default {"option":"style_option__rB93s","wrapper":"style_wrapper__VFRxf"};